import { useLoggedInQuery } from '@/src/common/gql/MesaGql'
import { GET_USER_INFO } from '../gql/queries/user'

export function useCardReferralCode() {
  const { data: userData } = useLoggedInQuery(GET_USER_INFO, {
    fetchPolicy: 'cache-and-network',
  })
  return userData?.getUserInfo.referralCode ?? ''
}
